export const qrCodeTranslations = {
  pt: {
    hero: {
      badge: "Gerador de QR Code",
      title: "Transforme qualquer link",
      titleHighlight: "em QR Code.",
      cta: "Gerar QR Code",
      loading: "Gerando..."
    },
    form: {
      urlLabel: "URL do link *",
      urlPlaceholder: "https://exemplo.com/meu-link",
      error: "Erro ao gerar QR Code",
      success: "QR Code gerado com sucesso!",
      copySuccess: "Link copiado para a área de transferência!",
      copyError: "Erro ao copiar link",
      downloadError: "Erro ao baixar QR code",
      download: "Baixar QR Code"
    }
  },
  en: {
    hero: {
      badge: "QR Code Generator",
      title: "Turn any link",
      titleHighlight: "into a QR Code.",
      cta: "Generate QR Code",
      loading: "Generating..."
    },
    form: {
      urlLabel: "Link URL *",
      urlPlaceholder: "https://example.com/my-link",
      error: "Error generating QR Code",
      success: "QR Code generated successfully!",
      copySuccess: "Link copied to clipboard!",
      copyError: "Error copying link",
      downloadError: "Error downloading QR code",
      download: "Download QR Code"
    }
  }
};
